export enum RankAssigmentAlgorithm {
    networkSimplex = 'network-simplex',
    tightTree = 'tight-tree',
    longestPath = 'longest-path',
}
